import { Injectable } from '@angular/core';
import { DeviceLocationDeviceDetail } from '../shared/models/device-location-device-detail.interface';
import { IBusyFirmwareStatusViewInfo, IFirmwareStatusViewInfo } from '../shared/models/models';
import FirmwareImageStatus = CASLink.Device.Ui.ViewModel.Device.FirmwareImageStatus;

@Injectable({
    providedIn: 'root',
})
export class FirmwareUpdateStatusViewInfoService {
    private readonly DEFAULT_SIZE: number = 24;
    private readonly DEFAULT_ICON: string = 'fiber_manual_record';

    public getState(item: DeviceLocationDeviceDetail): IBusyFirmwareStatusViewInfo | IFirmwareStatusViewInfo {
        const firmwareUpdateStatus = item?.firmwareUpdateStatus;
        if (firmwareUpdateStatus === null || firmwareUpdateStatus === undefined) {
            return null;
        }

        const statusType = {} as IFirmwareStatusViewInfo;
        if (firmwareUpdateStatus === FirmwareImageStatus.Busy) {
            return {
                status: firmwareUpdateStatus,
                totalPages: item?.pendingFirmwareVersionTotalPages,
                currentPage: item?.pendingFirmwareVersionCurrentPage
            } as IBusyFirmwareStatusViewInfo;
        }

        statusType.size = this.DEFAULT_SIZE;
        statusType.icon = this.DEFAULT_ICON;
        statusType.statusDescription = 'N/A';
        statusType.cls = 'firmware-status';

        switch (firmwareUpdateStatus) {
            case FirmwareImageStatus.BadImage:
                statusType.icon = 'error';
                statusType.statusDescription = 'Bad Image';
                statusType.cls = 'firmware-status-bad-image';
                // tslint:disable-next-line: no-magic-numbers
                statusType.size = 20;
                break;
            case FirmwareImageStatus.Current:
                statusType.statusDescription = 'Current';
                break;
            case FirmwareImageStatus.OnDeck:
                statusType.icon = 'file_download';
                statusType.statusDescription = 'On Deck';
                statusType.cls = 'firmware-status-on-deck';
                break;
            case FirmwareImageStatus.Previous:
                statusType.statusDescription = 'Previous';
                break;
            case FirmwareImageStatus.Ready:
                statusType.icon = 'done';
                statusType.statusDescription = 'Ready';
                statusType.cls = 'firmware-status-ready';
                break;
        }
        return statusType;
    }
}
